var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 10,
    viewBox: "0 0 43 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.320312 8.1005L0.756766 7.61315C1.74631 8.50055 2.65856 8.9132 3.98227 8.9132C5.30598 8.9132 6.2571 8.17565 6.2571 7.1753V7.15055C6.2571 6.2249 5.75585 5.68805 3.71243 5.288C1.55423 4.8632 0.679936 4.1504 0.679936 2.82515V2.8004C0.679936 1.49945 1.9009 0.5 3.57219 0.5C4.88294 0.5 5.74382 0.84965 6.65699 1.56245L6.23303 2.07455C5.38512 1.36175 4.53628 1.08725 3.54674 1.08725C2.22303 1.08725 1.34873 1.8248 1.34873 2.73785V2.7626C1.34873 3.68825 1.83702 4.25075 3.9707 4.6751C6.05207 5.0873 6.92636 5.81225 6.92636 7.08755V7.1123C6.92636 8.5253 5.67995 9.5 3.94524 9.5C2.50628 9.5 1.40057 9.0374 0.321238 8.1005H0.320312Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59951 5.52943V1.24137H12.1442C13.7636 1.24137 14.8684 1.96633 14.8684 3.35368V3.37843C14.8684 4.67847 13.7373 5.52853 12.0669 5.52853H10.5821V6.12793H12.0289C13.9053 6.12793 15.5377 5.17753 15.5377 3.34017V3.31543C15.5377 1.62792 14.1751 0.640625 12.196 0.640625H8.93164V9.39178H9.59998V6.12883",
    fill: "#1A1A1A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.262 5.17887V1.24137H29.3329C30.9654 1.24137 31.9156 1.97892 31.9156 3.15388V3.17863C31.9156 4.44132 30.7969 5.17887 29.2936 5.17887H27.2493V5.76613H29.2038L32.0697 9.39087H32.9176L29.949 5.65273C31.4652 5.45293 32.5834 4.61503 32.5834 3.15298V3.12823C32.5834 2.50318 32.3266 1.91593 31.9026 1.50328C31.3625 0.977675 30.4766 0.640625 29.3709 0.640625H25.5928V9.39178H26.2611V5.76702",
    fill: "#1A1A1A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9237 4.92777L34.4807 0.640625H35.2777L38.3486 4.50297L41.407 0.640625H42.1915L38.7346 4.92868L42.3207 9.39178H41.5237L38.3236 5.35438L35.1361 9.39178H34.3516L37.9237 4.92868V4.92777Z",
    fill: "#1A1A1A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5679 1.9274L23.0263 8.76065H16.1008L19.5679 1.9274ZM19.5689 0.5L15.0576 9.39155H24.069L19.5689 0.5Z",
    fill: "url(#paint0_linear_25143_63404)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25143_63404",
    x1: 15.694,
    y1: 9.9689,
    x2: 22.2769,
    y2: 4.25769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#652092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#F54DE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#FF83B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD83"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a367dd9112fc3c56f07c2d409bd4c329.svg";
export { ForwardRef as ReactComponent };